import React, {Fragment} from 'react'
import {Route} from '../components/Router'
import {Navigation} from '../components/Navigation'

import {Browser} from '../components/rmg';

export default function RmgContainer(){
    return (
        <Fragment>
            <Route path="/rmg/" exact={true} component={Browser} />
            <Route path="/rmg/browser/" exact={true} component={Browser} />
            <Route path="/rmg/browser/:sportIdForMarkets/markets" exact={true} component={Browser} />
            <Route path="/rmg/browser/:sportIdForEvents/events" exact={true} component={Browser} />
            <Route path="/rmg/browser/:sportIdForCategories/categories" exact={true} component={Browser} />
            <Route path="/rmg/browser/:sportIdForTournaments/categories/:categoryIdForTournaments/tournaments" exact={true} component={Browser} />
            <Route path="/rmg/browser/:sportIdForEvents/categories/:categoryIdForEvents/tournaments/:tournamentIdForEvents/events" exact={true} component={Browser} />
        </Fragment>
    )
}